export const REGULAR_SPACE = ' ';
/**
 * This may seem like a regular space symbol, but it's not.
 * It's actually a special japanese space.
 */
export const JAPANESE_SPACE = '　';
/**
 * This pattern include REGULAR_SPACE and JAPANESE_SPACE
 */
export const ALL_SPACES_PATTERN = ' 　';

export const FORBIDDEN_SLUG_CHARACTERS = [
    ':',
    '/',
    '?',
    '#',
    '[',
    ']',
    '@',
    '!',
    '$',
    '&',
    "'",
    '(',
    ')',
    '*',
    '+',
    ',',
    ';',
    '=',
    '.',
    ' ',
];

export const FORBIDDEN_SLUG_CHARACTERS_REGEXP = new RegExp(`[${FORBIDDEN_SLUG_CHARACTERS.join('\\')}]+`, 'g');

/**
 * Reserved words comes from the backoffice in: https://github.com/lumapps/core/blob/b8b3eb26f7a46c9e5555bf9bf901a79d62a7b99b/core/monolite/server/content/__init__.py#L50C1-L72
 * Any changes made to that list must be reflected in the back-office too.
 *
 * List all the reserved words that cannot be used in a content slug.
 * Those words are used for product pages.
 * */
export const FORBIDDEN_SLUG_RESERVED_WORDS = [
    'new',
    'edit',
    'view',
    'details',
    'registration',
    'progress',
    'admin',
    'news',
    'logout',
    'login',
    'settings',
    'access-denied',
    'search',
    'content',
    'ls',
];

export const FORBIDDEN_SLUG_RESERVED_WORDS_REGEXP = new RegExp(
    `^(/?|[0-9a-zA-Z_-]+/)*(${FORBIDDEN_SLUG_RESERVED_WORDS.join('|')})(/?|/[0-9a-zA-Z_-]+)+$`,
);

/**
 * Regex to detect if a string includes a `@` mention.
 * Example of matching texts:
 * `@foo`
 * `test @foo`
 * `test @foo something`
 *
 * If the `@` mention is joined to another string (something@else), the regex won't match
 */
export const AT_MENTION_REGEXP = /(?:(?:\s@)|^@)([^\s]+)/;
